import React from 'react';

export default props => (
  <div className="loading-spin-pone">
    <div className="loading-spin-ptwo" {...props.isItem ? { style: { top: -16 } } : {}}>
      <div className="loading-spin-container">
        <div className="loading-spin">
          <div><div /></div>
          <div><div /></div>
          <div><div /></div>
          <div><div /></div>
          <div><div /></div>
          <div><div /></div>
          <div><div /></div>
          <div><div /></div>
        </div>
      </div>
    </div>
  </div>
);
